import React, { Component } from 'react';
import { selectors, actions } from './sagas/sign_up/new';
import { TextInput } from './shared/TextInput'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormError } from './shared/FormError'
import { Kegmeisters } from './Keg';
import './stylesheets/sign_up.sass'

class SignUp extends Component {
  constructor(props) {
    super(props)
    this.submitUserForm = this.props.submitUserForm.bind(this)
    this.getLinkId() && this.props.checkInviteLink(this.getLinkId())
  }

  handleCustomSubmit = () => {
    this.submitUserForm(this.props.user_form)
  }

  getLinkId = () => {
    let link_id = this.props
    && this.props.match
    && this.props.match.params
    && this.props.match.params.link_id
    return link_id
  }

  render () {
    const { handleSubmit } = this.props
    return (
      <div className={'sign-up'}>
        <div className={'sign-up-wrapper'}>
          <form onSubmit={handleSubmit(this.handleCustomSubmit)}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 315, marginBottom: 30 }}>
              <Kegmeisters
                fontSize={72}
                kegClassName={'d-inline-block'}
                wrapperClassName={'homebutton d-inline-block'}
                meistersClassName={'d-inline-block'}
                kegColor={'#FDBF20'}
                meistersColor={'#303030'}
              />
            </div>
            <div className={'sign-up-title'}>
              Create Your Account
            </div>
            { !!this.props.errors && Object.keys(this.props.errors).length > 0 &&
              <FormError errors={this.props.errors}/>
            }
            { this.getLinkId() &&
              <div className={'invite'}>
                Congratulations on being invited to join Kegmeisters!
              </div>
            }
            { !this.getLinkId() &&
              <div>
                <TextInput
                  placeholderText={'Email'}
                  inputName={'email'}
                  label={'Email'}
                  validate={'email'}
                />
                <TextInput
                  placeholderText={'First Name'}
                  inputName={'first_name'}
                  label={'First Name'}
                />
                <TextInput
                  placeholderText={'Last Name'}
                  inputName={'last_name'}
                  label={'Last Name'}
                />
                <TextInput
                  placeholderText={'Password'}
                  inputName={'password'}
                  label={'Password'}
                  validate={'password'}
                />
                <TextInput
                  placeholderText={'Password Confirmation'}
                  inputName={'password_confirmation'}
                  label={'Password Confirmation'}
                  validate={'password'}
                />
                <input
                  value="Continue"
                  type="submit"
                  id='continue-button' />
              </div>
            }
            { this.props.checking_link &&
              <div>
                Loading...
              </div>
            }
            { this.getLinkId() && this.props.link_valid && !this.props.checking_link &&
            <div>
              <TextInput
                placeholderText={'Email'}
                inputName={'email'}
                label={'Email'}
                validate={'email'}
              />
              <TextInput
                placeholderText={'Password'}
                inputName={'password'}
                label={'Password'}
                validate={'password'}
              />
              <TextInput
                placeholderText={'Password Confirmation'}
                inputName={'password_confirmation'}
                label={'Password Confirmation'}
                validate={'password'}
              />
              <input
                value="Continue"
                type="submit"
                id='continue-button' />
            </div>
            }
          </form>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  user_form: selectors.new_user_form(store),
  errors: selectors.errors(store),
  checking_link: selectors.checking_link(store),
  link_valid: selectors.link_valid(store)
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);

export default (connect(
  mapStateToProps, mapDispatchToProps)(
  reduxForm(
  { form: 'new_user'}
)(SignUp)));



// WEBPACK FOOTER //
// ./src/SignUp.jsx